import StatusPage from './StatusPage.jsx';

/** 403 — authenticated, but the account's role doesn't allow this page. */
export default function Forbidden403() {
  return (
    <StatusPage
      code="403"
      title="You don't have access to this"
      message="Your account is signed in but its role doesn't include this area. Ask a platform administrator if you think you should have access."
      icon="fa fa-shield-alt"
      tone="danger"
    />
  );
}
